/**
 * The label field - used for Google Analytics
 */
function backupType(type, isNotarized) {
  if (isNotarized) {
    return {
      i18nKey: 'wr-dashboard.side-bar.backup-type.notarized',
      label: 'notarize'
    };
  }

  if (type === 'FILE') {
    return {
      i18nKey: 'wr-dashboard.side-bar.backup-type.file',
      label: 'file'
    };
  }

  if (type === 'IMAGE') {
    return {
      i18nKey: 'wr-dashboard.side-bar.backup-type.disk',
      label: 'image'
    };
  }

  if (type === 'EXCHANGE' || type === 'EXCHANGE_DOC' || type === 'EXCHANGE_UNKNOWN') {
    return {
      i18nKey: 'wr-dashboard.side-bar.backup-type.exchange',
      label: 'ms_exchange'
    };
  }

  if (type === 'SQL') {
    return {
      i18nKey: 'wr-dashboard.side-bar.backup-type.sql',
      label: 'ms_sql_server'
    };
  }

  if (type === 'SYS_STATE') {
    return {
      i18nKey: 'wr-dashboard.side-bar.backup-type.sys-state',
      label: 'system_state'
    };
  }

  if (type === 'VSS_APPLICATION' || type === 'APPLICATION') {
    return {
      i18nKey: 'wr-dashboard.side-bar.backup-type.application',
      label: 'application'
    };
  }

  console.log('Undefined backup type', type);
  return {
    i18nKey: 'undefined',
    label: 'undefined'
  };
}

export default backupType;
